module.exports = __webpack_public_path__ + "img/p4.0ca1eaaa.png";